import { JsonObject, JsonProperty } from 'json2typescript'
import DateConverter from '@/converters/DateConverter'
import { DefinedListDetail } from './DefinedList'
import Model from './Model'

@JsonObject('PersonalDetailsModel')
export default class PersonalDetails extends Model {
  @JsonProperty('title', DefinedListDetail)
  title: DefinedListDetail = new DefinedListDetail()

  @JsonProperty('firstName', String)
  firstName = ''

  @JsonProperty('lastName', String)
  lastName = ''

  @JsonProperty('dateOfBirth', DateConverter)
  dateOfBirth: Date = new Date()
}
